import { Spinner } from "components/ui/spinner";
import React from "react";
import { useProductBranding } from "store/selectors/branding";
import { useFeature, useFeaturesQuery, useRegionId } from "store/selectors/hooks";
import { LeadSourcesSettings } from "./lead-sources-settings";
import { LeadSourcesUpsell } from "./lead-sources-upsell";

const useLeadSourcesGatesLoading = (): boolean => {
    const regionId = useRegionId();
    const featuresQuery = useFeaturesQuery();
    const productBranding = useProductBranding();
    return productBranding.isLoading || (!!regionId && featuresQuery.isLoading);
};

export const LeadSourcesSettingsRoute: React.FC<unknown> = () => {
    const gatesLoading = useLeadSourcesGatesLoading();
    const isHomeCareEnabled = useFeature("homeCarePrototype");
    const isPlacementIntakeEnabled = useFeature("placementLeadIntake");

    if (gatesLoading) {
        return <Spinner />;
    }
    return isHomeCareEnabled || isPlacementIntakeEnabled ? (
        <LeadSourcesSettings />
    ) : (
        <LeadSourcesUpsell />
    );
};
